import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCircleNotch } from '@fortawesome/free-solid-svg-icons';

export default function AssetTag(props) {
  const {
    tagName,
    tagValue,
    handleDelete,
    tagID,
    deleteTagRequestPending,
    hideDeleteButton,
  } = props;
  return (
    <div className="col-auto p-0">
      <div className="float-left bg-white pr-2 text-black tag-label">
        <span className="font-weight-bold ml-2">{tagName}</span> : {tagValue}
        {hideDeleteButton ? null : (
          <button
            onClick={() => handleDelete(tagID)}
            className="btn btn-link text-decoration-none p-0 text-hr-gray ml-2 mr-1"
          >
            {deleteTagRequestPending === tagID ? (
              <FontAwesomeIcon
                icon={faCircleNotch}
                spin
                color="var(--brand-primary-alert)"
              />
            ) : (
              <FontAwesomeIcon icon={faTimes} />
            )}
          </button>
        )}
      </div>
      <style jsx>{`
        .tag-label {
          margin: 0.2rem;
          padding: 0.2rem;
          border-radius: 6px;
          border: 0.5px solid var(--third-gray);
          font-size: 14px;
        }
        button:hover {
          color: var(--error-red) !important;
        }
      `}</style>
    </div>
  );
}

AssetTag.propTypes = {
  tagName: PropTypes.string,
  tagValue: PropTypes.string,
  tagID: PropTypes.string,
  deleteTagRequestPending: PropTypes.string,
  handleDelete: PropTypes.func,
  hideDeleteButton: PropTypes.bool,
};
